import { api } from "./api";

const vid = () => {
  let v = localStorage.getItem("mm_vid");
  if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("mm_vid", v); }
  return v;
};

export function track(event, path = window.location.pathname, meta = "") {
  if (path.startsWith("/admin") || navigator.webdriver) return;
  api.post("/track", { event, path, referrer: event === "pageview" ? document.referrer : "", vid: vid(), width: window.innerWidth, meta }).catch(() => {});
}
